import type { FleetGroup } from '#domain/FleetGroup.ts';

import type { ApiTag } from '../tagsApi.slice.ts';

export const mapTagToFleetGroup = (tag: ApiTag): FleetGroup => ({
    id: tag.id,
    name: tag.name,
});

export const mapTagsToFleetGroups = (tags: ApiTag[]): FleetGroup[] => tags.map(mapTagToFleetGroup);
